import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { api } from "../../helpers/utils";

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg('');

    try {
      const res = await api.post('/admin-login', { username, password });

      if (res.data?.token) {
        localStorage.setItem('authToken', res.data.token);
        localStorage.setItem('isAdmin', true);
        navigate('/admin/home');
      } else {
        setErrorMsg('Invalid response. Try again.');
      }
    } catch (err) {
      console.error('Login error:', err);
      setErrorMsg('Login failed. Please check your credentials.');
    }
  };

  return (
    <Page>
      <Card>
        <Heading>Admin Login</Heading>
        <Form onSubmit={handleLogin}>
          <Input type="text" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} required />
          <Input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {errorMsg && <ErrorText>{errorMsg}</ErrorText>}
          <PrimaryButton type="submit">Login</PrimaryButton>
        </Form>
      </Card>
    </Page>
  );
};

export default LoginPage;

const Page = styled.div`
  min-height: 100vh;
  background: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
`;

const Card = styled.div`
  width: 100%;
  max-width: 420px;
  padding: 40px 32px 70px;
  background: #050505;
  border: 1px solid #303030;

  @media (max-width: 500px) {
    padding: 30px 22px 60px;
  }
`;

const Heading = styled.h2`
  text-align: center;
  margin-bottom: 30px;
  font-size: 30px;
  font-weight: 700;
  color: #ffffff;

  @media (max-width: 500px) {
    font-size: 24px;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const Input = styled.input`
  padding: 14px;
  border: 1px solid #303030;
  background-color: #000000;
  color: #ffffff;
  font-size: 16px;
  outline: none;
  transition: border 0.2s ease;

  &:focus {
    border-color: #ffffff;
  }
`;

const PrimaryButton = styled.button`
  padding: 16px;
  border: 1px solid #ffffff;
  background: #ffffff;
  color: #000000;
  font-weight: 800;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;

  &:hover {
    background: #000000;
    color: #ffffff;
    transform: translateY(-2px);
  }

  @media (max-width: 500px) {
    position: sticky;
    bottom: 15px;
  }
`;

const ErrorText = styled.p`
  color: #ffffff;
  text-align: center;
  font-size: 14px;
  margin: -4px 0 0;
`;
